import React from "react";
import styled from "styled-components";
import { EXTENDED_CURRENCY_FLAGS } from "../../../../components/common/ExtendedCurrencyFlags";

interface FlagIconProps {
    length: number;
  }


const FlagIcon = styled.span<FlagIconProps>`
  background-size: contain;
  height: ${(props: { length: number }) => props.length ? `${props.length}px` : "25px"};
  width: ${(props: { length: number }) => props.length ? `${props.length}px` : "25px"};
  border-radius: 50px;
  margin-right: 8px;
`

const CurrencyFlag = ({ currency, length }: {currency?: string, length?: number}) => {
  const customFlag = EXTENDED_CURRENCY_FLAGS[currency?.toLowerCase()]

  return customFlag ?
    <img src={customFlag} width={length || "25px"} height={length || "25px"} style={{borderRadius: "50px", marginRight: "8px"}} /> :
    <FlagIcon className={`currency-flag currency-flag-${currency?.toLowerCase()}`} length={length} />
}

export default CurrencyFlag;